import { useFormData } from '@/composables/useFormData';
import Labour from '@/models/Labour';
import LabourService from '@/services/LabourService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useLaboursStore = defineStore('labours', {
  state: () => ({
    filter: useFormData({
      first_name: undefined,
      last_name: undefined,
      supplier_name: undefined,
      day_min: undefined,
      day_max: undefined,
      wbs_code_id: undefined,
      vendor_ref: undefined,
    }),

    active: false,
  }),

  getters: {
    models: () => useRepo(Labour),
  },

  actions: {
    resetFilter() {
      this.active = false;
      this.filter.resetData();
    },

    async fetchLabours(projectId: Id, form: ApiRequests['api.v1.labours.index'] = {}) {
      const [data, error] = await LabourService.index(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async fetchLabour(id: Id) {
      const [data, error] = await LabourService.show(id);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async fetchDailyLabours(projectId: Id, day: ApiRequests['api.v1.plants.daily']) {
      const [data, error] = await LabourService.daily(projectId, day);

      if(error) {
        throw error;
      }

      return this.models.save(data);
    },

    async saveLabour(projectId: Id, labour: ApiRequests['api.v1.labours.store']) {
      const [data, error] = await LabourService.create(projectId, labour);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateLabour(id: Id, labour: ApiRequests['api.v1.labours.update']) {
      const [data, error] = await LabourService.update(id, labour);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteLabour(id: Id) {
      const [data, error] = await LabourService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },

    async fetchForSubcontractorClaim(projectId: Id, claimId: Id) {
      const [data, error] = await LabourService.fetchForSubcontractorClaim(projectId, claimId);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },
  },

  persist: {
    storage: sessionStorage,
  },
});
